import React from "react";
import { useTranslation } from "react-i18next";

import classNames from "classnames";

export default function MyBetsBetItemDetails_ToggleButton(props: {
	isDetailsOpen: boolean;
	setIsDetailsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
	const { t } = useTranslation("mybets");

	const text = !props.isDetailsOpen
		? t("REPORTS.SHOW_DETAILS")
		: t("REPORTS.HIDE_DETAILS");

	const iconClasses = classNames(
		"u-icon u-icon--xtny u-icon--animation-reset",
		{
			"u-icon--caret--right": !props.isDetailsOpen,
			"u-icon--caret--up": props.isDetailsOpen,
		}
	);

	return (
		<button
			className="btn btn--xsml btn--reset btn--ghost btn--icon u-color--text--secondary"
			onClick={() => props.setIsDetailsOpen(!props.isDetailsOpen)}
		>
			<span className="btn__label u-type--xxsml">{text}</span>
			<i className={iconClasses} />
		</button>
	);
}
